import styled from 'styled-components';

export const CustomTitle = styled.span`
	font-size: 1.5rem;
	font-weight: 600;
	line-height: normal;

	@media (max-width: 576px) {
		font-size: 1.2rem;
	}
`;
